// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function TotalMonthlyDifferenceRow() {
   const state = useQuoteContext()
   const { getString } = state

   if (state.differenceQuote == true)
      return (
         <div className='row grey-bold'>
            <div className='col-bhr1 col-bhr5'>
               <b>
                  {getString('product.TotalMonthlyDifferenceRow.Header.Title')}
               </b>
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               <b>
                  {formatFloatAsCurrencySymbol(
                     state.monthlyTotal.totalPriceDifference,
                     state.currencyObject,
                  )}
               </b>
            </div>
         </div>
      )
}
